// SERVICES
import { gql } from "@/services/httpAdapter";
const subscriptionQueries = (locationId: string) => {
	return [
		{
			context: "onCreateQueue",
			query: gql`
				subscription onCreateQueue($locationId: String!) {
					onCreateQueue(locationId: $locationId) {
						_id
						locationId
						name
						overflowQueues
						usersByPosition {
							_id
							name
							users {
								_id
								name
							}
						}
					}
				}
			`,
			variables: {
				locationId,
			},
		},
		{
			context: "onUpdateQueue",
			query: gql`
				subscription onUpdateQueue($locationId: String!) {
					onUpdateQueue(locationId: $locationId) {
						_id
						locationId
						name
						overflowQueues
						usersByPosition {
							_id
							name
							users {
								_id
								name
							}
						}
					}
				}
			`,
			variables: {
				locationId,
			},
		},
		{
			context: "onDeleteQueue",
			query: gql`
				subscription onDeleteQueue($locationId: String!) {
					onDeleteQueue(locationId: $locationId) {
						locationId
						queues {
							_id
							locationId
							name
							overflowQueues
							usersByPosition {
								_id
								name
								users {
									_id
									name
								}
							}
						}
					}
				}
			`,
			variables: {
				locationId,
			},
		},
	];
};

export default subscriptionQueries;
